// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"ba34d6d8","689":"192e20af"}[chunkId] + ".chunk.js";
};